import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '@emotion/react';
import { createPolymorphicComponent, useAdaptiveHeightContext, useSlot, AdaptiveHeightProvider } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { isThemeToken } from '@nettbureau/theme';

/**
 * A stacked item. Should be direct children of a stack component. Useful when you want to override
 * how an individual item is rendered.
 */ const Item = createPolymorphicComponent((props, ref)=>{
    const adaptiveHeight = useAdaptiveHeightContext();
    const [mergedProps, mergedRef] = useSlot('Item', props, ref);
    const { align, as: Component = 'div', children, css, grow, height, margin, maxHeight, maxWidth, minHeight, minWidth = 0, order, padding, shrink, width, ...otherProps } = mergedProps;
    const theme = useTheme();
    const heightToken = height === 'auto' ? adaptiveHeight : isThemeToken(height, theme.heights) ? height : undefined;
    const itemCss = useCss(({ mixins })=>[
            mixins.flexItem({
                align,
                grow,
                order,
                shrink,
                width
            }),
            mixins.size({
                height: heightToken ?? height,
                maxHeight,
                maxWidth,
                minHeight,
                minWidth,
                width
            }),
            mixins.spacing({
                margin,
                padding
            })
        ]);
    return /*#__PURE__*/ jsx(Component, {
        "data-stack-item": true,
        ...otherProps,
        ref: mergedRef,
        css: [
            itemCss,
            css
        ],
        children: /*#__PURE__*/ jsx(AdaptiveHeightProvider, {
            value: heightToken ?? null,
            children: children
        })
    });
});

export { Item };
//# sourceMappingURL=item.js.map
